import { Badge } from '@/components/ui/Badge/Badge';

/** Угловой бейдж «Без правок» в правом верхнем углу ячейки названия (слева от бейджа комментария). */
export function ProjectNoEditsCornerBadge() {
  return (
    <span className="projects-table__no-edits-corner-badge" aria-hidden>
      <Badge variant="custom" bg="var(--gradient-error)" color="#fff">
        Без правок
      </Badge>
    </span>
  );
}
